import { render, staticRenderFns } from "./NotificationManagement.vue?vue&type=template&id=571c6ec0&scoped=true"
import script from "./NotificationManagement.vue?vue&type=script&lang=ts"
export * from "./NotificationManagement.vue?vue&type=script&lang=ts"
import style0 from "./NotificationManagement.vue?vue&type=style&index=0&id=571c6ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c6ec0",
  null
  
)

export default component.exports